import styled from "styled-components";

export const BaseModal = styled.div`
  background-color: #fff;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  position: absolute;
  inset: 0;
  margin: auto;
  padding: 1em;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`

export const BaseModalForm = styled.form`
  background-color: var(--color-white);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 1em;
  border-radius: 15px;
  position: absolute;
  inset: 0;
`